/**
 * ProtectedRoute 컴포넌트
 * 인증된 사용자만 접근 가능한 라우트
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

/**
 * ProtectedRoute Props
 */
interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * ProtectedRoute 컴포넌트
 * 인증 확인 및 리다이렉트
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuthStore();

  // 로딩 중: 픽셀 스피너 표시
  if (isLoading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-center">
          <div
            className="inline-block bg-[#9bbc0f] p-8 mb-4 animate-pulse"
            style={{
              border: '4px solid #1f2937',
              boxShadow: 'inset 0 2px 10px rgba(0,0,0,0.3)',
            }}
          >
            <div className="text-[#0f380f] font-pixel text-2xl">
              LOADING...
            </div>
          </div>
        </div>
      </div>
    );
  }

  // 미인증: 로그인 페이지로 리다이렉트
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 인증됨: 자식 컴포넌트 렌더링
  return <>{children}</>;
};
